export class TipoConteudoModel {
  id: number;
  descricao: String;
}



// WEBPACK FOOTER //
// /app/src/app/model/caixa/tipoconteudo.model.ts